/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Regionalpricingbadge_Belowsuggested3Inputs */

const id_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran ini sebenarnya di bawah itu juga — penawaran yang bagus di semua sisi.`)
};

const ms_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran ini sebenarnya di bawah itu juga — tawaran hebat di semua sudut.`)
};

const da_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette tilbud er faktisk også under det — et fantastisk tilbud hele vejen rundt.`)
};

const de_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Angebot liegt tatsächlich auch darunter — insgesamt ein großartiges Angebot.`)
};

const en_us2_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is actually below that too — a great deal all around.`)
};

const es_es2_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta está por debajo de eso también — una gran oferta en todos los sentidos.`)
};

const es_mx2_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta está por debajo de eso también — una gran oferta en todos los sentidos.`)
};

const fil_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang deal na ito ay mas mababa pa riyan — isang mahusay na deal sa lahat ng aspeto.`)
};

const fr_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette offre est également en dessous de ce montant — une excellente affaire à tous points de vue.`)
};

const it_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa offerta è addirittura inferiore — un ottimo affare a tutto tondo.`)
};

const hu_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az ajánlat még ez alatt is van — nagyszerű ajánlat minden szempontból.`)
};

const nl_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze deal zit daar zelfs onder — een geweldige deal in alle opzichten.`)
};

const no_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette tilbudet er faktisk under det også — et flott tilbud på alle måter.`)
};

const pl_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta oferta jest poniżej sugerowanej — świetna okazja.`)
};

const pt_br2_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is actually below that too — a great deal all around.`)
};

const pt_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta oferta está abaixo do sugerido — uma excelente oferta.`)
};

const ro_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această ofertă este chiar sub aceasta — o ofertă excelentă.`)
};

const fi_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä tarjous on jopa sen alapuolella — erinomainen diili.`)
};

const sv_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta erbjudande är faktiskt under det också — ett utmärkt erbjudande.`)
};

const vi_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi này thực sự thấp hơn mức đó nữa — một ưu đãi tuyệt vời toàn diện.`)
};

const tr_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu fırsat aslında bunun da altında — her açıdan harika bir anlaşma.`)
};

const cs_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato nabídka je ve skutečnosti ještě pod touto úrovní — skvělá nabídka ve všech směrech.`)
};

const bg_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тази оферта всъщност е под това — страхотна сделка във всяко отношение.`)
};

const ru_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это предложение на самом деле ниже этого — отличная сделка во всех отношениях.`)
};

const uk_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ця пропозиція навіть нижча за рекомендовану — чудова знижка.`)
};

const ar_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا العرض أقل من ذلك أيضًا — صفقة رائعة من جميع النواحي.`)
};

const hi_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शानदार डील!`)
};

const th_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอนี้ต่ำกว่านั้นเช่นกัน — เป็นข้อเสนอที่ยอดเยี่ยมรอบด้าน`)
};

const ja_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この取引はそれよりもさらに低く、あらゆる面でお得です。`)
};

const zh_cn2_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is actually below that too — a great deal all around.`)
};

const zh_hant1_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is actually below that too — a great deal all around.`)
};

const ko_components_regionalpricingbadge_belowsuggested3 = /** @type {(inputs: Components_Regionalpricingbadge_Belowsuggested3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This deal is actually below that too — a great deal all around.`)
};

/**
* | output |
* | --- |
* | "This deal is actually below that too — a great deal all around." |
*
* @param {Components_Regionalpricingbadge_Belowsuggested3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_regionalpricingbadge_belowsuggested3 = /** @type {((inputs?: Components_Regionalpricingbadge_Belowsuggested3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Regionalpricingbadge_Belowsuggested3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "ms") return ms_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "da") return da_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "de") return de_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "en-US") return en_us2_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "es-ES") return es_es2_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "es-MX") return es_mx2_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "fil") return fil_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "fr") return fr_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "it") return it_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "hu") return hu_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "nl") return nl_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "no") return no_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "pl") return pl_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "pt-BR") return pt_br2_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "pt") return pt_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "ro") return ro_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "fi") return fi_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "sv") return sv_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "vi") return vi_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "tr") return tr_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "cs") return cs_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "bg") return bg_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "ru") return ru_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "uk") return uk_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "ar") return ar_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "hi") return hi_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "th") return th_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "ja") return ja_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_regionalpricingbadge_belowsuggested3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_regionalpricingbadge_belowsuggested3(inputs)
	return ko_components_regionalpricingbadge_belowsuggested3(inputs)
});
export { components_regionalpricingbadge_belowsuggested3 as "components.regionalPricingBadge.belowSuggested" }